import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { Department } from '../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../shared/components/genericBaseModelDropDown';
import { DepartmentService } from '../../../../shared/services/department.service';


@Component({
  selector: 'app-department-drop-down',
  template: '',
  imports: [
    CommonModule,
    FormlyModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class DepartmentDropDownComponent extends GenericBaseModelDropDown<Department> {

  constructor(
    private departmentService: DepartmentService
  ) {
    super(departmentService, "Department");
  }

}
